(() => {
  function init(root = document) {
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const gallery = section.querySelector('[data-gallery]');
      const slides = [...gallery.querySelectorAll('[data-slide]')];
      const thumbs = [...gallery.querySelectorAll('[data-thumbnail]')];
      let activeSlide = 0;
      const show = index => {
        index = (index + slides.length) % slides.length;
        activeSlide = index;
        const counter = gallery.querySelector('[data-gallery-count]');
        if (counter) counter.textContent = String(index + 1);
        slides.forEach((slide, i) => { slide.hidden = i !== index; });
        thumbs.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      };
      if (slides.length) {
        show(0);
        gallery.querySelector('.gallery-thumbs').hidden = false;
        thumbs.forEach((button, i) => button.addEventListener('click', () => show(i)));
        gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(activeSlide - 1));
        gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(activeSlide + 1));
        let startX = null;
        gallery.querySelector('.gallery-stage')?.addEventListener('touchstart', e => { startX = e.changedTouches[0].clientX; }, {passive:true});
        gallery.querySelector('.gallery-stage')?.addEventListener('touchend', e => { if (startX === null) return; const dx = e.changedTouches[0].clientX-startX; if(Math.abs(dx)>45) show(activeSlide+(dx<0?1:-1)); startX=null; }, {passive:true});
      }
      const selector = section.querySelector('[data-variant-select]');
      if (!selector) return;
      const cards = [...section.querySelectorAll('[data-variant-card]')];
      cards.forEach(card => card.addEventListener('click', () => {
        if (card.disabled) return;
        selector.value = card.dataset.variantCard;
        selector.dispatchEvent(new Event('change', {bubbles:true}));
      }));

      const updateOfferUI = selected => {
        const priceText = selected.dataset.price || '';
        const compareText = selected.dataset.compare || '';
        const savingsText = selected.dataset.savingsAmount || '';
        const savingPercent = selected.dataset.savingPercent || '';
        const hasDiscount = Boolean(compareText);

        const compare = section.querySelector('[data-compare]');
        compare.textContent = compareText;
        compare.hidden = !hasDiscount;

        const offer = section.querySelector('[data-offer]');
        if (offer) offer.hidden = !hasDiscount;

        const savingPercentEls = section.querySelectorAll('.offer-pill[data-saving-percent]');
        savingPercentEls.forEach(el => { el.textContent = hasDiscount ? `${savingPercent}% OFF` : ''; });

        const compareCopy = section.querySelector('[data-compare-copy]');
        if (compareCopy) compareCopy.textContent = compareText;

        const priceCopy = section.querySelector('[data-price-copy]');
        if (priceCopy) priceCopy.textContent = priceText;

        const saveCopy = section.querySelector('[data-save-copy]');
        if (saveCopy) {
          saveCopy.textContent = hasDiscount ? `You save ${savingsText}` : '';
          saveCopy.hidden = !hasDiscount;
        }

        const buttonSubtitleText = hasDiscount ? `Digital download · Save ${savingPercent}% today` : 'Digital PDF download';
        section.querySelectorAll('[data-button-subtitle]').forEach(el => { el.textContent = buttonSubtitleText; });
        section.querySelectorAll('[data-button-price]').forEach(el => { el.textContent = priceText; });

        const stickySaving = section.querySelector('[data-sticky-saving]');
        if (stickySaving) {
          stickySaving.textContent = hasDiscount ? `${savingPercent}% OFF` : '';
          stickySaving.hidden = !hasDiscount;
        }
      };

      const update = () => {
        const selected = selector.selectedOptions[0];
        const available = selected.dataset.available === 'true';
        cards.forEach(card => card.setAttribute('aria-pressed', String(card.dataset.variantCard === selected.value)));
        section.querySelector('[data-price]').textContent = selected.dataset.price;
        section.querySelector('[data-sticky-price]').textContent = selected.dataset.price;
        section.querySelector('[data-unit-price]').textContent = selected.dataset.unitPrice || '';
        updateOfferUI(selected);
        section.querySelectorAll('[data-add]').forEach(button => { button.disabled = !available; });
        section.querySelectorAll('[data-add-label]').forEach(label => { label.textContent = available ? (label.dataset.availableLabel || 'Add to cart') : 'Sold out'; });
        const accelerated = section.querySelector('[data-dynamic-checkout]');
        if (accelerated) accelerated.hidden = !available;
        const quantity = section.querySelector('[name="quantity"]');
        quantity.min = selected.dataset.min || '1';
        quantity.step = selected.dataset.step || '1';
        if (selected.dataset.max) quantity.max = selected.dataset.max;
        else quantity.removeAttribute('max');
        quantity.value = quantity.min;
        const imageIndex = slides.findIndex(slide => slide.dataset.mediaId && slide.dataset.mediaId === selected.dataset.mediaId);
        if (imageIndex >= 0) show(imageIndex);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selected.value);
        window.history.replaceState({}, '', url);
      };
      selector.addEventListener('change', update);
      const mainButton = section.querySelector('.product-form [data-add]');
      const sticky = section.querySelector('.sticky-buy');
      if (mainButton && sticky && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          sticky.classList.toggle('is-visible', !entries[0].isIntersecting && mainButton.getBoundingClientRect().top < 0);
        }, {threshold:0});
        observer.observe(mainButton);
      }
      const initialImage = selector.selectedOptions[0]?.dataset.mediaId;
      const initialIndex = slides.findIndex(slide => slide.dataset.mediaId && slide.dataset.mediaId === initialImage);
      if (initialIndex >= 0) show(initialIndex);
      update();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
